import TagsCtrl from './controllers/index';
import TagCreateCtrl from './controllers/create';
import TagShowCtrl from './controllers/show';
import TagExportCtrl from './controllers/export';
import Tag from './tag.repository';
import TagSelectCreate from './directives/tagSelectCreate';
import subscriberFormTagSelect from './directives/subscriberFormTagSelect';
import tagSelectWithNegative from './directives/tagSelectCreateWithNegative';
import TagSelect from './directives/tagSelect';
import routing from './tag.routes';
import uirouter from 'angular-ui-router';

export default angular.module('app.tag', [uirouter])
    .config(routing)
    .controller('TagsCtrl', TagsCtrl)
    .controller('TagCreateCtrl', TagCreateCtrl)
    .controller('TagShowCtrl', TagShowCtrl)
    .controller('TagExportCtrl', TagExportCtrl)
    .directive('tagSelect', () => new TagSelect)
    .directive('tagSelectCreate', () => new TagSelectCreate)
    .directive('subscriberFormTagSelect', () => new subscriberFormTagSelect)
    .directive('tagSelectWithNegative', () => new tagSelectWithNegative)
    .service('Tag', Tag)
    .name;

